import * as React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { useLocation } from 'react-router-dom';
import { Footer, LoggedOutHeader, SkipToMain } from '../components';
import { useMfsReplatformEnabled } from '../modules/mfs-replatform';

interface Props {
  children: React.ReactNode;
}

export default function LoggedOutLayout({ children }: Props) {
  const classes = useStyles();
  const location = useLocation();
  const mfsReplatformEnabled = useMfsReplatformEnabled();
  const isReplatformLogin = mfsReplatformEnabled && location.pathname === '/login';

  if (isReplatformLogin) {
    return (
      <div className={classes.replatformRoot}>
        <SkipToMain id="main" />

        <main id="main" className={classes.replatformContent}>
          {children}
        </main>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <SkipToMain id="main" />
      <LoggedOutHeader />

      <main id="main" className={classes.content}>
        {children}
      </main>

      <Footer />
    </div>
  );
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: tokens.colorNeutralBackground1,
    overflowX: 'hidden',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
  },
  replatformRoot: {
    minHeight: '100vh',
    backgroundColor: tokens.colorNeutralBackground2,
    overflowX: 'hidden',
  },
  replatformContent: {
    minHeight: '100vh',
  },
});
